// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__n-h4J","info":"Footer_info__g6Sbt"};